import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, MenuItem, Typography, Chip } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

export function DynamicSubmenuItem({ subItem, subIndex, hasDivider, onClose, isItemRegistered }) {
    if (subItem.isDivider) {
        return (
            <Box key={`divider-${subIndex}`}>
                {subIndex > 0 && <Box sx={{ height: '1px', bgcolor: 'divider', my: 1, mx: 2 }} />}
                {subItem.path ? (
                    <MenuItem
                        component={Link}
                        to={subItem.path}
                        onClick={onClose}
                        sx={{
                            px: 2.5,
                            py: 0.75,
                            minHeight: 'unset',
                            cursor: 'pointer',
                            width: '100%',
                            boxSizing: 'border-box',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            '&:hover': {
                                bgcolor: 'action.hover',
                                '& .MuiTypography-root': {
                                    color: 'primary.dark',
                                },
                                '& .arrow-icon': {
                                    transform: 'translateX(2px)',
                                    color: 'primary.dark',
                                },
                            },
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                color: 'primary.main',
                                fontWeight: 700,
                                lineHeight: 1.2,
                                letterSpacing: '0.08em',
                            }}
                        >
                            {subItem.label}
                        </Typography>
                        <ArrowForward
                            className="arrow-icon"
                            sx={{
                                fontSize: '0.85rem',
                                color: 'primary.main',
                                transition: 'transform 0.15s ease-in-out',
                            }}
                        />
                    </MenuItem>
                ) : (
                    <Box sx={{ px: 2.5, pt: 1, pb: 0.5 }}>
                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 'bold', lineHeight: 1 }}>
                            {subItem.label}
                        </Typography>
                    </Box>
                )}
            </Box>
        );
    }

    if (subItem.disabled || !subItem.path) {
        return (
            <MenuItem
                key={subItem.label}
                disabled
                sx={{
                    py: 1,
                    px: 2.5,
                    fontSize: '0.85rem',
                    fontStyle: 'italic',
                    color: 'text.secondary',
                    pl: hasDivider ? 3.5 : 2.5,
                }}
            >
                {subItem.label}
            </MenuItem>
        );
    }

    return (
        <MenuItem
            key={subItem.label}
            component={Link}
            to={subItem.path}
            onClick={onClose}
            sx={{
                py: 1,
                px: 2.5,
                fontSize: '0.85rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1.5,
                pl: hasDivider ? 3.5 : 2.5,
                '&:hover': {
                    bgcolor: 'hero.main',
                    color: 'white',
                    '& .registered-chip': {
                        bgcolor: 'white',
                        color: 'success.dark',
                    }
                },
            }}
        >
            <span>{subItem.label}</span>
            {isItemRegistered?.(subItem) && (
                <Chip
                    className="registered-chip"
                    label="Registered"
                    size="small"
                    color="success"
                    sx={{
                        height: 20,
                        fontSize: '0.68rem',
                        fontWeight: 700,
                        cursor: 'pointer',
                    }}
                />
            )}
        </MenuItem>
    );
}

DynamicSubmenuItem.propTypes = {
    subItem: PropTypes.object.isRequired,
    subIndex: PropTypes.number.isRequired,
    hasDivider: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    isItemRegistered: PropTypes.func,
};

export default DynamicSubmenuItem;
